const baseballDrills = [
  //done
  {
    id: 2140,
    name: 'Beginner Hitting Basics',
    categories: ['Hitting', 'beginner'],
    sports: ['baseball'],
    difficulty: 'beginner',
    skill: 'Hitting',
    points: 30,
    instructions:
      "Welcome to the Big Leagues! Today, you're the star slugger, and we're going to practice hitting home runs! We'll learn a powerful stance, a super-fast swing, and play some awesome hitting games. Let's grab a bat and get ready to CRUSH it!",
    timedInstructions: [
      {
        time: 0,
        text: "Hello, Big Leaguer! Before we start, let's remember our safety rules! We are only using soft foam or wiffle balls, and we are only hitting into a net or a soft wall. Make sure your space is clear!",
      },
      {
        time: 15,
        text: "Great! Let's warm up! Let's do ten big arm circles forward... and ten big arm circles backward!",
      },
      {
        time: 35,
        text: 'Awesome! Now plant your feet and do twenty torso twists, side to side! Get your body ready to swing!',
      },
      {
        time: 55,
        text: "Perfect! Now let's get our mind ready with Super Focus Mode! Close your eyes for a second. Picture yourself at a big baseball game. You hit the ball and it's a home run! See it fly! Okay, open your eyes! Let's do this!",
      },
      {
        time: 75,
        text: "First, we need to build your All-Star Stance! Let's learn the four secret steps. Step one: Superhero Feet! Put your feet a little wider than your shoulders.",
      },
      {
        time: 90,
        text: "Step two: Springy Knees! Bend your knees a little so you're ready to bounce and move!",
      },
      {
        time: 105,
        text: 'Step three: The Grip! Hold your bat with your hands together. A fun trick is to line up your door-knocking knuckles! Hold it strong but not too tight!',
      },
      {
        time: 125,
        text: "And step four: Ready Position! Hold the bat up by your back shoulder, pointing up a little bit. Like you're getting ready to launch a rocket!",
      },
      {
        time: 145,
        text: "Let's play the Stance Check Game! I'll call out a body part, you check it! Ready? FEET! ... KNEES! ... GRIP! ... BAT POSITION! Awesome! Let's do that seven more times! Get into your stance from standing tall!",
      },
      {
        time: 205,
        text: "You've got the stance, now let's perfect your Rocket Swing! This also has four steps! We'll do this without a ball first. This is called a shadow swing.",
      },
      {
        time: 225,
        text: "Step one: The Coil! From your stance, you do a tiny turn backwards, loading up your power like you're winding up a toy!",
      },
      {
        time: 240,
        text: 'Step two: The Step! Take a tiny step forward with your front foot. Not too big!',
      },
      {
        time: 255,
        text: 'Step three: The Launch! Turn your belly button to the net and swing the bat fast and level! Make a whoosh sound!',
      },
      {
        time: 270,
        text: 'And step four: The Superhero Pose! After you swing, finish with the bat wrapped around your back and hold your balance like a statue for three seconds! Three, two, one!',
      },
      {
        time: 290,
        text: "Let's do ten perfect shadow swings! Remember all four steps! Coil, step, LAUNCH, and pose! Let's see it!",
      },
      {
        time: 340,
        text: 'Great swings! Time for our first game: TEE BALL BLAST-OFF! Put a ball on the tee right in the middle, about belly-button height.',
      },
      {
        time: 360,
        text: "The goal is to hit a frozen rope! That's a super straight line drive right into the net! We are going to hit fifteen balls. After every swing, you must hold your Superhero Pose! Ready? Ball one!",
      },
      {
        time: 380,
        text: 'Great hit! Hold that pose! Reset your feet. Ball two! Coil, step, LAUNCH!',
      },
      {
        time: 400,
        text: 'Awesome! Remember to keep your eyes on the ball! Ball three! See it, hit it! Remember to squish the bug with your back foot when you swing!',
      },
      {
        time: 425,
        text: "Keep going! Make every swing the same! Smooth and powerful! We're on ball six! Halfway there!",
      },
      {
        time: 475,
        text: "You're doing great! Up to ball ten now! Five more perfect swings! You look like a real pro!",
      },
      {
        time: 528,
        text: 'Last one! Number fifteen! Make this your best hit of the day! And... hold that pose! Fantastic!',
      },
      {
        time: 548,
        text: "Time for Game Two: PAINTING THE CORNERS! A great hitter can hit the ball no matter where it's pitched! First, we'll practice on the inside corner.",
      },
      {
        time: 568,
        text: "Move the tee a little closer to your body. To hit this ball, you have to be extra quick with your hands! Let's hit eight inside pitches! Go!",
      },
      {
        time: 628,
        text: "Great job being quick! Now for the outside corner! Move the tee a little farther away from you. You have to reach for this one! Let's hit eight outside pitches! Go!",
      },
      {
        time: 688,
        text: "You're painting the corners like a pro! Let's do another round! Four more inside, and four more outside! Finish strong!",
      },
      {
        time: 738,
        text: "You've passed every test! This is it! The moment we've all been waiting for... THE HOME RUN DERBY!",
      },
      {
        time: 753,
        text: 'You have ninety seconds to hit as many home runs as you can off the tee! A home run is any ball you hit super hard right into the net! Reset the ball as fast as you can! On your mark... get set... GO!',
      },
      {
        time: 798,
        text: "You're halfway there! 45 seconds left! Keep swinging! How many home runs can you get? Every swing is a power swing!",
      },
      {
        time: 843,
        text: 'Ten, nine, eight, seven, six, five, four, three, two, one! TIME! YOU ARE THE HOME RUN CHAMPION! Give a big cheer!',
      },
      {
        time: 865,
        text: "WOW! What an amazing performance! Let's do our Big League Cool-down. Take a deep breath! You earned it!",
      },
      {
        time: 880,
        text: 'Time for our final Super Focus Mode. Close your eyes. Picture the best swing you had today. The one that felt powerful and smooth. See it in your mind.',
      },
      {
        time: 900,
        text: "Now open your eyes. Let's do one, perfect, slow-motion shadow swing, just like the one in your mind. Hold that Superhero Pose at the end.",
      },
      {
        time: 920,
        text: "Great focus! Now let's stretch. Hold the bat behind your back and gently stretch your chest. Hold for ten seconds.",
      },
      {
        time: 940,
        text: 'Now, plant your feet and do five slow torso twists to stretch your back. Great job today, slugger!',
      },
      {
        time: 960,
        text: 'You learned how to stand and swing like a real Big Leaguer, and you won the Home Run Derby! Give yourself a big clap!',
      },
    ],
    timeTotal: 970,
    equipment:
      'Foam or wiffle balls, bat or short bat, tee, hitting net or padded wall',
  },
  //done
  {
    id: 2141,
    name: 'Intermediate Hitting Contact and Timing',
    categories: ['Hitting', 'intermediate'],
    sports: ['baseball'],
    difficulty: 'intermediate',
    skill: 'Hitting',
    points: 42,
    instructions:
      "Welcome back to the Big Leagues, All-Star! Today's mission is all about timing and making awesome contact with the ball. We're going to learn how to hit the ball early, late, inside, and outside, just like the pros! Let's get our timing perfect and hit some frozen ropes!",
    timedInstructions: [
      {
        time: 0,
        text: "Hello, All-Star! Before we start our training, let's do our safety check! Remember, we are only using soft foam or wiffle balls, and only hitting into a net or a soft wall. Let's get ready to train like a pro!",
      },
      {
        time: 15,
        text: "Let's warm up! Grab your bat. Let's do ten big, slow arm circles forward... and ten big arm circles backward!",
      },
      {
        time: 35,
        text: 'Awesome! Now plant your feet and do twenty torso twists, side to side! Get your body ready to swing!',
      },
      {
        time: 55,
        text: "Great! Let's get our mind ready with Super Focus Mode! Close your eyes for a second. Picture a laser beam shooting from your bat right to the middle of the net! See the perfect line drive! Okay, open your eyes! Let's make it happen!",
      },
      {
        time: 75,
        text: "Today is all about timing! And great timing starts with great rhythm! Get in your All-Star Stance. To find our rhythm, we're going to use a tiny toe-tap with our front foot. Tap your toe, and when it lands, that's your signal to swing! Tap, land, SWING!",
      },
      {
        time: 100,
        text: "Let's practice that with shadow swings, no ball yet! We'll do twenty perfect shadow swings with our new rhythm. Find a smooth groove. Ready? Tap, land, SWING! And hold that superhero pose!",
      },
      {
        time: 150,
        text: "Great rhythm! Now for our first game: THE TIMING WINDOW! A great hitter can hit the ball whether it's early, on time, or late. Let's start with the perfect ON-TIME pitch. Put the ball on the tee right in the middle.",
      },
      {
        time: 175,
        text: "Let's hit ten balls right down the middle! Use your toe-tap rhythm for every single swing! Go!",
      },
      {
        time: 225,
        text: "Perfect! Now, let's practice hitting an EARLY pitch! Move the tee a little bit in front of you. You have to be quicker to hit this one! The goal is to hit it to the 'pull' side of the net, the same side of your body that you are!",
      },
      {
        time: 255,
        text: "Let's hit ten early pitches! Be quick with your hands and turn fast! Go!",
      },
      {
        time: 305,
        text: "Great job being quick! Now for a LATE pitch! Move the tee a little bit back, closer to you. You have to wait on this one! The goal is to hit it to the 'opposite' side of the net. Let the ball get to you!",
      },
      {
        time: 335,
        text: "Let's hit ten late pitches! Wait for it... wait for it... and drive it the other way! Go!",
      },
      {
        time: 385,
        text: 'You are a master of timing! Shake your arms out! Time for our next game: THE HIGH AND LOW CHALLENGE!',
      },
      {
        time: 400,
        text: "First, the low pitch! Lower the tee so the ball is about at your knees. To hit this ball, you have to really use your legs and stay down! Don't just swing with your arms!",
      },
      {
        time: 420,
        text: "Let's hit ten low frozen ropes! Stay down and drive it! Go!",
      },
      {
        time: 470,
        text: "Awesome! Now for the high pitch! Raise the tee up to about chest height. The secret here is to stay on TOP of the ball. Don't swing up! Swing level!",
      },
      {
        time: 490,
        text: "Let's hit ten high line drives! Stay on top of it! Go!",
      },
      {
        time: 540,
        text: "You can hit any pitch, anywhere! That's what an All-Star does! Okay, one more challenge. This is the most important one: THE TWO-STRIKE BATTLE!",
      },
      {
        time: 560,
        text: "When a real batter has two strikes, they don't swing for a home run. They just try to make contact! So we use a 'battle swing'. For a battle swing, we take a smaller step and a shorter, quicker swing. Just focus on hitting the ball!",
      },
      {
        time: 585,
        text: "Let's practice it! Imagine the bases are loaded, there are two outs, and you have two strikes! You have to get a hit! We are going to take twenty battle swings! Small step, quick swing, and hit a line drive! Let's go to battle!",
      },
      {
        time: 615,
        text: "Keep going! Just put the bat on the ball! Line drive after line drive! You're a clutch hitter!",
      },
      {
        time: 665,
        text: 'Five more battle swings! Finish strong! You won the game for the team!',
      },
      {
        time: 695,
        text: "You are a master of contact and timing! That was a real pro workout! It's time for our All-Star Cool-down.",
      },
      {
        time: 710,
        text: "Let's do our final Super Focus Mode. Close your eyes. Picture the best line drive you hit today. See the ball on the tee, see your perfect swing, and see the ball fly like a rocket into the net.",
      },
      {
        time: 735,
        text: "Now open your eyes. Let's do one, perfect, slow-motion shadow swing, just like the one in your mind. Hold that Superhero Pose at the end.",
      },
      {
        time: 755,
        text: "Great focus! Now let's stretch. Hold the bat on your shoulders behind your neck and gently twist side to side ten times to stretch your back.",
      },
      {
        time: 775,
        text: 'Now, hold the bat in front of you with both hands and gently stretch to the right to stretch your side... and now to the left. Great job today, All-Star!',
      },
      {
        time: 795,
        text: 'You learned how to hit any pitch like a pro and how to be a clutch hitter in a tough spot! Give yourself a big round of applause!',
      },
    ],
    timeTotal: 805,
    equipment:
      'Foam or wiffle balls, bat or short bat, tee, hitting net or padded wall',
  },
  //done
  {
    id: 2142,
    name: 'Advanced Hitting Bat Path and Power',
    categories: ['Hitting', 'advanced'],
    sports: ['baseball'],
    difficulty: 'advanced',
    skill: 'Hitting',
    points: 45,
    instructions:
      "Time to unlock your All-Star power! This advanced mission is all about learning the secrets to a powerful and consistent swing. We'll work on hitting the ball to all parts of the field, adjusting to different pitches, and finishing with a Power Hitting Challenge. Let's become the most feared hitter in the league!",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome, All-Star! Let's get to work! First, a quick safety check: We are only using soft foam or wiffle balls, and hitting only into a net or a soft wall. Make sure your space is clear!",
      },
      {
        time: 15,
        text: "Great! Let's warm up like a pro. Grab your bat. Feet planted, let's do twenty torso twists, side to side, to warm up your power engine!",
      },
      {
        time: 40,
        text: 'Awesome! Now, twenty big arm circles forward and backward to get your shoulders loose!',
      },
      {
        time: 65,
        text: "Perfect! Time for Super Focus Mode. Close your eyes. Picture your perfect, most powerful swing. Feel how your body turns. Feel the bat crushing the ball. See the ball flying like a rocket. Okay, open your eyes. Let's make that happen!",
      },
      {
        time: 90,
        text: "Today's big secret is the Power Engine! All your power comes from turning your hips and your body, NOT just your arms. Your hips start the swing, like pulling the cord on a lawnmower, and your hands follow!",
      },
      {
        time: 115,
        text: "Let's do a 'Hips First' drill with shadow swings. Get in your stance. Each time you swing, I want you to say out loud 'HIPS, HANDS, SWING!' Feel your hips start the turn first. Let's do ten shadow swings. Go!",
      },
      {
        time: 160,
        text: "Great job feeling that! Now, let's try it with the ball on the tee. Put the tee right in the middle. We're going to hit ten balls, and all I want you to think about is 'HIPS, HANDS, SWING!' Let's go!",
      },
      {
        time: 220,
        text: "You can feel that power, right? That's your engine working! Let's play our first game: ALL-STAR ALLEY RALLY! This game is about hitting the ball where it's pitched.",
      },
      {
        time: 245,
        text: "First, the inside pitch. Move the tee a little closer to your body. To hit this, you have to be quick and hit the ball to your 'pull alley,' which is the side of the net you are pulling the bat towards. Let's hit ten frozen ropes to the pull alley! Go!",
      },
      {
        time: 305,
        text: "Awesome job pulling the ball! Now for the outside pitch. Move the tee a little farther away from you. For this one, you hit it to the 'opposite field alley,' the other side of the net. Let's hit ten line drives to the opposite alley! Go!",
      },
      {
        time: 365,
        text: "You're hitting to all fields! Let's do another round! Five to the pull alley, five to the opposite alley! Be an expert!",
      },
      {
        time: 415,
        text: "Time for Game Two: THE ELEVATOR CHALLENGE! This is about hitting pitches at different heights. First, we're going to the 'ground floor.' Lower the tee so the ball is around your knees.",
      },
      {
        time: 440,
        text: "To hit this ball, you have to get low with your legs and stay down through your swing. Let's hit ten line drives from the ground floor! Go!",
      },
      {
        time: 500,
        text: "Great job getting low! Now we're going up to the 'penthouse'! Raise the tee so the ball is at the top of your strike zone, around your chest. Stay tall and swing level to crush this pitch! Let's hit ten from the penthouse!",
      },
      {
        time: 560,
        text: "You can hit them high and you can hit them low! Let's do a final round of the Elevator Challenge! Five from the ground floor, and five from the penthouse! Finish strong!",
      },
      {
        time: 620,
        text: 'Time for Game Three: THE TWO-STRIKE BATTLE! Oh no, the umpire says you have two strikes! This means no more giant home run swings. We just need to protect the plate and hit the ball!',
      },
      {
        time: 645,
        text: "For a battle swing, you make your stance a little smaller, and your swing a little shorter. Just focus on making contact. Let's do twenty two-strike battle swings! Choke up on the bat a little, take a small step, and just tap the ball into the net! Be a tough out!",
      },
      {
        time: 715,
        text: "Great job battling! That's how you win when the pressure is on! You have proven you are a smart hitter. But now... it's time to show your power!",
      },
      {
        time: 735,
        text: 'This is it! THE POWER HITTING CHALLENGE! The tee is back in the middle. You are back to your home run swing! You have ninety seconds. I want you to hit the ball as hard as you can, every single time! How many BOMBS can you hit into the net? Ready... GO!',
      },
      {
        time: 780,
        text: "You're halfway there! 45 seconds left! Use your HIPS FIRST to create that power! Let's see some monster hits!",
      },
      {
        time: 825,
        text: 'Ten, nine, eight, seven, six, five, four, three, two, one! TIME! That was some serious power!',
      },
      {
        time: 845,
        text: "You are the complete package! A smart AND powerful hitter! Let's do our All-Star Cool-down. Take a deep breath! You earned it!",
      },
      {
        time: 860,
        text: 'Time for our final Super Focus Mode. Close your eyes. Picture that last power swing you just took. Feel your hips turning. Feel the bat exploding through the ball. Lock that feeling in your memory.',
      },
      {
        time: 885,
        text: "Now open your eyes. Let's do one, perfect, slow-motion shadow swing, just like the one in your mind. Hold that Superhero Pose at the end.",
      },
      {
        time: 905,
        text: "Great focus! Now let's stretch. Hold the bat with both hands and gently do five side bends each way to stretch your sides. Slow and easy.",
      },
      {
        time: 930,
        text: 'Now, plant your feet and do five slow torso twists to stretch your back. Great job today, All-Star!',
      },
      {
        time: 950,
        text: 'You learned how to use your power engine and hit the ball all over the place. You are a true advanced hitter! Give yourself a big clap!',
      },
    ],
    timeTotal: 960,
    equipment:
      'Foam or wiffle balls, bat or short bat, tee, hitting net or padded wall',
  },
  //done
  {
    id: 2143,
    name: 'Beginner Fielding Basics',
    categories: ['Fielding', 'beginner'],
    sports: ['baseball'],
    difficulty: 'beginner',
    skill: 'Fielding',
    points: 30,
    instructions:
      "Get ready to become a Ground Ball Gobbler! This mission is all about becoming a fielding superstar. You'll learn the secret Superhero Stance, how to use your glove like a hungry monster, and play awesome games to stop any ball that comes your way. Let's get our gloves ready and have some fun!",
    timedInstructions: [
      {
        time: 0,
        text: "Hello, future Gold Glover! Before we start, let's remember our safety rules! We are only using a soft foam ball or a rolled-up sock. Make sure your space is clear and we are only doing gentle rolls!",
      },
      {
        time: 15,
        text: "Great! Let's get warmed up! Let's do ten Star Jumps to get our body moving! Go!",
      },
      {
        time: 30,
        text: 'Awesome! Now, twenty High Knees to get our feet ready! Get them up to your belly button! Go, go, go!',
      },
      {
        time: 50,
        text: "Perfect! Now, let's learn the most important move: the Superhero Stance! This is your ready position. Put your feet super wide, bend your knees, and get your bottom down low, like you're a superhero about to pounce!",
      },
      {
        time: 70,
        text: "Let your arms hang down and put your glove on the ground in front of you. That's it! Let's play a game! I want you to jog in place, and when I shout 'SUPERHERO STANCE', you drop down into your position as fast as you can! Ready?",
      },
      {
        time: 95,
        text: 'Jog, jog, jog... SUPERHERO STANCE! Get low! ... Great! Back to jogging!',
      },
      {
        time: 110,
        text: "Let's do it again! Jog, jog, jog... SUPERHERO STANCE! Faster this time! ... Awesome! One more time! Jogging... SUPERHERO STANCE! You're a pro!",
      },
      {
        time: 135,
        text: "Okay, now let's turn your glove into a hungry Ground Ball Monster! When you're in your Superhero Stance, your glove should be on the ground with its mouth wide open, ready to eat the ball! Your fingers should be touching the ground.",
      },
      {
        time: 160,
        text: "And here's a secret trick! Your other hand is the trap! As soon as the ball goes into your glove's mouth, your other hand comes over the top and traps it! We call this the Alligator Chomp! Let's practice! Open your glove monster's mouth... and CHOMP it shut with your other hand! Let's do ten Alligator Chomps!",
      },
      {
        time: 195,
        text: "Great chomps! After you chomp the ball, you have to bring it to your belly button to keep it safe! So it's: GOBBLE with the glove, CHOMP with the trap, and bring it to your BELLY! Let's practice that motion five times!",
      },
      {
        time: 225,
        text: "You're ready for our first game: THE ROLL AND GOBBLE! You're going to roll the ball out in front of you, then get in your Superhero Stance and get ready to gobble it up!",
      },
      {
        time: 245,
        text: "Okay, give the ball a gentle roll. Now, get in your stance! Get low! Glove monster open! Here comes the ball... GOBBLE, CHOMP, BELLY! And stand up tall! That's one! Let's do that nine more times!",
      },
      {
        time: 295,
        text: "Remember to keep your eyes on the ball the whole time! Watch it go all the way into your glove monster's mouth! We're on number five! Keep going!",
      },
      {
        time: 340,
        text: 'Last one! Make this your best one yet! Roll... get low... and GOBBLE, CHOMP, BELLY! Fantastic!',
      },
      {
        time: 360,
        text: "Time for Game Two: THE THREE-LANE CHALLENGE! A real superhero has to be able to move side to side! First, we'll practice on your glove side. For me, that's my left.",
      },
      {
        time: 380,
        text: "Roll the ball a little bit to your glove side. Take a quick shuffle step, get low in your Superhero Stance, and gobble it up! Let's do five to our glove side! Go!",
      },
      {
        time: 420,
        text: "Great job moving your feet! Now, let's do five rolls straight down the middle! This should be easy for you now!",
      },
      {
        time: 460,
        text: "Awesome! Now for the tricky one! Your backhand side! Roll the ball to your other side. You have to move your feet, get in front of the ball, and gobble it up! Let's try five on your backhand side!",
      },
      {
        time: 500,
        text: "You are a fielding machine! Let's do another round! Two to the glove side! Two to the middle! And two to the backhand side! Go!",
      },
      {
        time: 540,
        text: "Time for our last game: THE ONE-KNEE CHALLENGE! This is for when you need to be extra sure you don't miss the ball!",
      },
      {
        time: 555,
        text: "For this one, you're going to put one knee on the ground, and keep your other foot flat. This makes a wall so the ball can't get past you! Put your glove monster right in front. Now, roll the ball and practice your Alligator Chomp!",
      },
      {
        time: 580,
        text: "Let's do ten one-knee gobbles! Roll it out, get your knee down, and make the play! Go!",
      },
      {
        time: 630,
        text: "You're doing great! Keep your eyes on the ball! Five more!",
      },
      {
        time: 660,
        text: "You have passed all the challenges! It's time for the FINAL TEST: THE RAPID-FIRE ROUND! I'm going to call out a lane, and you have to roll the ball there and gobble it up as fast as you can! Ready?",
      },
      {
        time: 685,
        text: 'MIDDLE! ... GLOVE SIDE! ... BACKHAND! ... MIDDLE! ... BACKHAND! ... GLOVE SIDE! Faster!',
      },
      {
        time: 710,
        text: 'MIDDLE! GLOVE SIDE! BACKHAND! MIDDLE! GLOVE SIDE! BACKHAND! YOU ARE A GROUND BALL GOBBLING SUPERSTAR!',
      },
      {
        time: 735,
        text: 'YOU DID IT! You are officially a Gold Glover! Stand tall and take a deep breath! That was awesome!',
      },
      {
        time: 750,
        text: "Time for our champion's cool down. Let's do a gentle stretch for our legs. Stand up and reach down to touch your toes. Hold it for ten seconds.",
      },
      {
        time: 770,
        text: 'Great! Now stand with your feet wide and do five slow squats to stretch your hips. Down and up.',
      },
      {
        time: 790,
        text: 'You learned how to get in a perfect Superhero Stance and how to gobble up every ground ball. You should be very proud!',
      },
      {
        time: 805,
        text: "Let's finish with a sign of respect. Stand tall, feet together... and take a proud bow. Fantastic work today, hero!",
      },
    ],
    timeTotal: 815,
    equipment:
      'Glove optional, soft foam ball or rolled sock, small bucket or box, pad on wall optional',
  },

  //done
  {
    id: 2144,
    name: 'Intermediate Fielding Footwork',
    categories: ['Fielding', 'intermediate'],
    sports: ['baseball'],
    difficulty: 'intermediate',
    skill: 'Fielding',
    points: 45,
    instructions:
      "Welcome to the Gold Glove Training Academy! Today, we're learning the secret footwork of the pros to make you a fielding superstar. You'll learn how to move in every direction, gobble up ground balls like a vacuum, and make amazing plays. Let's get ready to own the field!",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome, Gold Glover! Before we start, let's remember our safety rules! We are only using a soft foam ball or a rolled-up sock, and we are only doing gentle rolls in a clear space!",
      },
      {
        time: 15,
        text: "Let's get warmed up! We need quick feet today! Let's do twenty Star Jumps! Go!",
      },
      {
        time: 35,
        text: 'Great! Now twenty Butt Kicks to get our legs ready! Go, go, go!',
      },
      {
        time: 55,
        text: "Awesome! Now let's practice side shuffles! Shuffle right for five steps, and shuffle left for five steps! Let's do that four times! Stay low!",
      },
      {
        time: 80,
        text: 'Perfect! Get in your Superhero Stance! Feet wide, knees bent, bottom low! Your Glove Monster is on the ground and ready to eat!',
      },
      {
        time: 100,
        text: "Today's biggest secret is the 'Right-Left-Gobble!' To be a smooth fielder, you step with your right foot, then your left foot just as your glove is gobbling up the ball! It keeps your body moving forward!",
      },
      {
        time: 125,
        text: "Let's practice the motion without a ball. Just say it and do it! 'Right, Left, GOBBLE!' Let's do that ten times! Get the rhythm!",
      },
      {
        time: 155,
        text: "Now, place the ball on the ground in front of you. Start a few steps back. I want you to walk up to it and do your 'Right-Left-Gobble!' Let's do that ten times to make it perfect!",
      },
      {
        time: 205,
        text: "You've got the rhythm! Time for our first game: THE THREE-LANE GAUNTLET! First, we'll work on balls hit to your right side.",
      },
      {
        time: 225,
        text: "Roll the ball to your right. You're going to 'Shuffle-Shuffle' to get in front of it, then do your 'Right-Left-Gobble!' Let's do ten ground balls to your right! Go!",
      },
      {
        time: 280,
        text: "Great job shuffling! Now, for balls hit to your left side! Roll the ball to your left, 'Shuffle-Shuffle' to get in front, then 'Right-Left-Gobble!' Let's do ten to your left!",
      },
      {
        time: 335,
        text: "Awesome! Now for the slow roller right at you! For this, you have to 'Charge!' Take small, fast steps in, and finish with your 'Right-Left-Gobble!' Let's do ten slow rollers!",
      },
      {
        time: 390,
        text: "You've passed the gauntlet! Time for Game Two: THE CROSSOVER CHALLENGE! This is for balls hit far away, when a shuffle isn't fast enough!",
      },
      {
        time: 410,
        text: "The secret is the Crossover Step! To go right, you cross your left foot over your right to start running! To go left, you cross your right foot over your left! It's a super-fast start!",
      },
      {
        time: 435,
        text: "Let's try it! Roll a ball far to your right. Do a big Crossover Step with your left foot, run to get in front of the ball, and gobble it up! Let's do ten to the right!",
      },
      {
        time: 490,
        text: "That's how you get to the tough plays! Now let's go to the left! Roll it far to your left, Crossover with your right foot, and chase it down! Ten times!",
      },
      {
        time: 545,
        text: "You've got amazing range! Now let's work on the trickiest plays: the Backhand and Forehand! Get ready!",
      },
      {
        time: 560,
        text: "First is the Forehand, or the 'Glove-Side Grab!' Roll the ball to your glove side, just outside your foot. You have to get low and reach with your glove. Let's do ten Glove-Side Grabs!",
      },
      {
        time: 610,
        text: "Nice job! Now for the famous Backhand! This is the 'Bare-Hand-Side Grab!' Roll the ball to your other side. You have to reach across your body and get your glove down low. It's a tough play! Let's do ten Backhands!",
      },
      {
        time: 660,
        text: "That was a big league play! You are ready for the final test! THE GOLD GLOVE GAUNTLET! I'm going to call out a play, and you have to make it! Get in your Superhero Stance!",
      },
      {
        time: 685,
        text: 'SLOW ROLLER, CHARGE! ... SHOT TO YOUR RIGHT! (Shuffle!) ... SHOT TO YOUR LEFT! (Shuffle!) ... DEEP SHOT TO YOUR RIGHT! (Crossover!) ... DEEP SHOT TO YOUR LEFT! (Crossover!) ... BACKHAND! ... FOREHAND!',
      },
      {
        time: 725,
        text: "Let's go again, faster! SLOW ROLLER! ... RIGHT! ... LEFT! ... DEEP RIGHT! ... DEEP LEFT! ... BACKHAND! ... FOREHAND! YOU ARE A GOLD GLOVER!",
      },
      {
        time: 760,
        text: 'YOU DID IT! You have graduated from the Gold Glove Academy! Stand tall and take a deep breath! That was awesome!',
      },
      {
        time: 775,
        text: "Time for our Gold Glover Cool-down. Let's do a gentle stretch for our legs. Sit down and put the bottoms of your feet together, and gently press your knees down. Hold for ten seconds.",
      },
      {
        time: 795,
        text: 'Great! Now stand up and cross your right leg over your left, and reach down to touch your toes. Hold it... and switch legs.',
      },
      {
        time: 815,
        text: 'You learned how to move like a pro and gobble up every kind of ground ball. You should be very proud!',
      },
      {
        time: 825,
        text: "Let's finish with a sign of respect. Stand tall, feet together... and take a proud, Gold Glover's bow. Fantastic work today, hero!",
      },
    ],
    timeTotal: 835,
    equipment:
      'Glove optional, soft foam ball or rolled sock, small bucket or box, tape line or cones, wall pad optional',
  },
  //done
  {
    id: 2144,
    name: 'Intermediate Fielding Footwork',
    categories: ['Fielding', 'intermediate'],
    sports: ['baseball'],
    difficulty: 'intermediate',
    skill: 'Fielding',
    points: 45,
    instructions:
      "Ready to get lightning-fast feet? This mission is all about becoming a fielding ninja! You'll learn super-quick footwork, how to get to every ball, and how to make awesome plays. Let's turn you into the best infielder in the league!",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome, Fielding Ninja! Let's get to work! First, our safety check: We are only using a soft foam ball or a rolled-up sock. Make sure your space is clear for moving!",
      },
      {
        time: 15,
        text: "Great! Let's warm up! Twenty Star Jumps to get our body moving! Go!",
      },
      {
        time: 40,
        text: 'Awesome! Now, twenty High Knees to get our feet ready for action! Get them up to your belly button! Go, go, go!',
      },
      {
        time: 65,
        text: "Now, let's practice our ready position with a game! I want you to jog in place, and when I shout 'SUPERHERO STANCE', you drop down into your fielding position as fast as you can! Ready?",
      },
      {
        time: 85,
        text: 'Jog, jog, jog... SUPERHERO STANCE! Get low! ... Great! Back to jogging!',
      },
      {
        time: 100,
        text: "Let's do it again! Jog, jog, jog... SUPERHERO STANCE! Faster this time! ... Awesome! One more time! Jogging... SUPERHERO STANCE! You're a pro!",
      },
      {
        time: 125,
        text: "Okay, let's learn the secret to getting to every ball: The 'Right-Left-Gobble' move! For a right-handed fielder, as the ball comes, you step with your right foot, then your left foot, and then you GOBBLE the ball up! Let's practice that footwork without a ball. Just say it out loud: RIGHT-LEFT-GOBBLE! Let's do that ten times!",
      },
      {
        time: 165,
        text: "Great rhythm! Now, let's try it with a ball. Roll the ball out slowly, and as it comes to you, get your feet moving! RIGHT-LEFT-GOBBLE! Remember to use your Alligator Chomp and bring it to your belly! Let's do ten of these!",
      },
      {
        time: 225,
        text: "You're looking smooth! Keep your eyes on the ball the whole time! Five more! RIGHT-LEFT-GOBBLE!",
      },
      {
        time: 265,
        text: "Fantastic! Time for our first big challenge: THE THREE-LANE DASH! First, we need to learn the Shuffle Step. It's just quick little side steps without crossing your feet! Let's shuffle right five times, and left five times!",
      },
      {
        time: 295,
        text: "Now, roll the ball to your glove side! Shuffle over, do your RIGHT-LEFT-GOBBLE, and make the play! Let's do five to our glove side!",
      },
      {
        time: 335,
        text: 'Great job! Now, five rolls straight down the middle! This should be easy for you now! RIGHT-LEFT-GOBBLE!',
      },
      {
        time: 375,
        text: "Awesome! Now for the backhand side! Roll the ball to your other side. Shuffle over, get in front, and RIGHT-LEFT-GOBBLE! Let's do five on your backhand side!",
      },
      {
        time: 415,
        text: "You're covering all the lanes! Let's do a rapid-fire round! One to the glove side, one middle, one backhand! Go!",
      },
      {
        time: 445,
        text: "Time for our next ninja move: THE CROSSOVER STEP! This is for when you need to move really fast to get a ball far away! To go to your right, you cross your left foot over your right to start running! Let's practice that. Cross over and shuffle! And back!",
      },
      {
        time: 475,
        text: "Okay, roll the ball way out to your glove side! Use a big Crossover Step to get there, then do your RIGHT-LEFT-GOBBLE! Let's do five of these!",
      },
      {
        time: 515,
        text: "Now to your backhand side! Roll it way out! Crossover with your other foot to get there fast! Let's do five backhand Crossover Steps!",
      },
      {
        time: 555,
        text: "You're so fast! Time for the SLOW ROLLER CHALLENGE! Sometimes the ball is hit really slowly, and you have to run to it! We call this 'charging the ball'!",
      },
      {
        time: 575,
        text: "Roll the ball out very slowly. Now, run to it with fast, choppy steps! As you get close, do your RIGHT-LEFT-GOBBLE! Don't wait for the ball, you go get it! Let's do ten slow rollers!",
      },
      {
        time: 635,
        text: 'Keep your eyes down on the ball! You have to be aggressive! Five more! Charge!',
      },
      {
        time: 675,
        text: 'You have learned all the ninja footwork! It is time for the GOLD GLOVE GAUNTLET! I am going to call out a play, and you have to do it as fast as you can! Ready?',
      },
      {
        time: 700,
        text: 'SLOW ROLLER! (Charge it!) ... BALL TO YOUR GLOVE SIDE! (Shuffle!) ... BALL TO YOUR BACKHAND! (Shuffle!) ... FAR BALL TO YOUR GLOVE SIDE! (Crossover!)',
      },
      {
        time: 730,
        text: 'Get ready, faster now! FAR BACKHAND! (Crossover!) ... SLOW ROLLER! ... MIDDLE! ... GLOVE SIDE!',
      },
      {
        time: 760,
        text: 'Final round, lightning speed! GLOVE SIDE! BACKHAND! SLOW ROLLER! CROSSOVER! MIDDLE! YOU ARE A GOLD GLOVE NINJA!',
      },
      {
        time: 790,
        text: 'YOU DID IT! You are officially a master of footwork! Stand tall and take a deep breath! That was awesome!',
      },
      {
        time: 805,
        text: "Time for our champion's cool down. Let's do a gentle stretch for our legs. Stand up and reach down to touch your toes. Hold it for ten seconds.",
      },
      {
        time: 825,
        text: 'Great! Now stand with your feet wide and do five slow squats to stretch your hips. Down and up.',
      },
      {
        time: 845,
        text: 'You learned how to move like a real pro today, with shuffles, crossovers, and charges! You should be very proud!',
      },
      {
        time: 860,
        text: "Let's finish with a sign of respect. Stand tall, feet together... and take a proud bow. Fantastic work today, hero!",
      },
    ],
    timeTotal: 870,
    equipment:
      'Glove optional, soft foam ball or rolled sock, small bucket or box, tape line or cones, wall pad optional',
  },
  //done
  {
    id: 2146,
    name: 'Beginner Throwing Basics',
    categories: ['Throwing', 'beginner'],
    sports: ['baseball'],
    difficulty: 'beginner',
    skill: 'Throwing',
    points: 30,
    instructions:
      "Time for some Laser-Arm Training! This mission is all about learning to throw a baseball like a superstar pitcher. We'll learn the secret grip, the power position, and play some awesome accuracy games to hit any target you want. Let's get ready to fire some fastballs!",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome, Pitcher! Before we start our Laser-Arm Training, let's go over the safety rules! We are only using a soft foam ball or a rolled-up sock. Make sure your space is clear of anything breakable!",
      },
      {
        time: 15,
        text: "Great! Let's get your arm warmed up! Let's do ten big arm circles forward... and ten big arm circles backward! Nice and slow!",
      },
      {
        time: 40,
        text: 'Now, ten small, fast arm circles forward... and ten small, fast ones backward! Get the blood flowing!',
      },
      {
        time: 60,
        text: "Perfect! Now let's do twenty wrist circles! Ten one way, and ten the other! And let's get our feet moving with some fast feet in place for ten seconds! Go!",
      },
      {
        time: 85,
        text: "Awesome! Now let's learn the first secret: The Rocket Grip! To make the ball fly straight, put your first two fingers across the seams or lines on the ball, and your thumb right underneath. It should make a 'C' shape with your hand! Let's practice holding that!",
      },
      {
        time: 110,
        text: "Next is the Power Position! This is how you aim! You're going to point your glove hand's elbow right at your target, and make a big 'T' shape with your arms, like an airplane! This loads up all your power!",
      },
      {
        time: 135,
        text: "Let's play 'Ready, Set, T-Pose!' I want you to stand ready, and when I shout 'T-POSE!', you get into your power position as fast as you can! Ready? T-POSE! ... Great! Back to ready.",
      },
      {
        time: 155,
        text: "Let's do that five more times! T-POSE! ... Ready! ... T-POSE! ... Ready! ... Keep going! Make it sharp!",
      },
      {
        time: 185,
        text: "You've got the power position! Time for our first game: THE WRIST FLICK CHALLENGE! This helps make your wrist super strong.",
      },
      {
        time: 200,
        text: "I want you to kneel down on both knees so we only use our arm. We're going to do twenty gentle throws to your partner or a spot on the wall. The trick is, you can only flick your wrist! No big wind-up! Just FLICK!",
      },
      {
        time: 225,
        text: "Let's make it a game! You get 1 point for hitting the target, and 3 points for a bullseye! Let's do ten throws and see how many points you can get! Go!",
      },
      {
        time: 270,
        text: "Great flicks! Let's do another round of ten! Try to beat your score!",
      },
      {
        time: 315,
        text: "Awesome job! Stand up and shake your arm out! Now it's time to use your whole body in the POINT-AND-FIRE DRILL!",
      },
      {
        time: 335,
        text: "The secret to throwing lasers is to always point at your target first! So, you're going to step with your front foot and POINT it right at the target. At the same time, you point your glove elbow at the target, making your T-Pose. Then, you FIRE!",
      },
      {
        time: 360,
        text: "Let's do twenty throws, just like that. I want to see you POINT... and then FIRE! Step, point, THROW! Remember to follow through, letting your arm swing down to your opposite pocket.",
      },
      {
        time: 420,
        text: "You're halfway there! Ten more! Make every throw exactly the same! Point... and FIRE! Your arm is a laser beam!",
      },
      {
        time: 480,
        text: "Fantastic! You are so accurate! Now let's test that accuracy in... THE ACCURACY GAUNTLET! I'm going to call out a target on your partner or the wall, and you have to hit it! Ready?",
      },
      {
        time: 505,
        text: 'First target... aim for their RIGHT KNEE! Point and fire! ... Did you hit it? Great! Next target... LEFT SHOULDER! Point and fire!',
      },
      {
        time: 535,
        text: 'Awesome! Next target... their GLOVE! Give them an easy catch! Point and fire! ... And now... their BELLY BUTTON! Point and fire!',
      },
      {
        time: 565,
        text: "Let's do another round! Faster this time! RIGHT SHOULDER! ... LEFT KNEE! ... BELLY BUTTON! ... GLOVE! You're a human sniper!",
      },
      {
        time: 600,
        text: "You've passed every test! This is the final challenge! It's time for THE LASER SHOW! This is a speed and accuracy round!",
      },
      {
        time: 620,
        text: 'You have ninety seconds to make as many accurate throws as you can. Every throw that hits the target is a point! How many points can you score? On your mark... get set... GO!',
      },
      {
        time: 665,
        text: "You're halfway there! 45 seconds left! Don't just throw fast, throw accurately! Point and fire! Let's go!",
      },
      {
        time: 710,
        text: 'Ten, nine, eight, seven, six, five, four, three, two, one! TIME! That was an amazing laser show!',
      },
      {
        time: 730,
        text: "WOW! You are an official laser-arm pitcher! Let's do our pitcher's cool-down. Take a deep breath! You earned it!",
      },
      {
        time: 745,
        text: 'Gently pull your right arm across your chest and hold for ten seconds to stretch your shoulder... and now switch to the left arm.',
      },
      {
        time: 770,
        text: 'Now, reach your right arm up and pat yourself on the back. Use your other hand to gently pull the elbow. Hold for ten seconds... and switch arms.',
      },
      {
        time: 795,
        text: 'You learned the Rocket Grip, the T-Pose, and you dominated the accuracy games! You should be very proud!',
      },
      {
        time: 810,
        text: "Let's finish like the pros do. Stand tall, and give a little tip of your cap to your partner or target. Now, feet together... and take a proud pitcher's bow. Fantastic work today!",
      },
    ],
    timeTotal: 820,
    equipment: 'Foam or soft ball; optional taped target on wall',
  },
  //done
  {
    id: 2147,
    name: 'Intermediate Throwing Accuracy',
    categories: ['Throwing', 'intermediate'],
    sports: ['baseball'],
    difficulty: 'intermediate',
    skill: 'Throwing',
    points: 45,
    instructions:
      "Get ready for a laser show! Today, you're going to become a pitching ace with pinpoint accuracy. This mission is all about learning the secrets to a perfect throw. We'll play awesome target-hitting games and turn your arm into a laser cannon! Let's get ready to fire some fastballs!",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome, future pitching ace! Before we start our laser show, let's check our safety rules! We are only using a soft foam ball or a rolled-up sock, and we have a clear space with a safe wall target or net. No hard throws inside!",
      },
      {
        time: 15,
        text: "Great! Let's warm up that golden arm! Start with ten big arm circles forward with your throwing arm... and now ten big arm circles backward!",
      },
      {
        time: 35,
        text: 'Awesome! Now the other arm! Ten forward, and ten backward!',
      },
      {
        time: 50,
        text: "Now, plant your feet and do twenty torso twists, side to side, to warm up your body's power engine!",
      },
      {
        time: 75,
        text: "Perfect! Now let's practice our throwing motion without a ball. We call these shadow throws! Just copy me: Point your front shoulder at the target, take a small step with your front foot, and then throw, finishing with your hand by your opposite pocket! Let's do ten shadow throws!",
      },
      {
        time: 110,
        text: "Great warm-up! You're ready to throw! Grab your soft ball. We're going to learn the three secret steps to a perfect throw: Point, Step, and Throw!",
      },
      {
        time: 130,
        text: "First, find your target on the wall. A piece of tape works great! Now, POINT your front shoulder and your glove right at that target. It's like you're aiming a laser!",
      },
      {
        time: 150,
        text: 'Next, you STEP with your front foot, right towards the target. And finally, you THROW the ball, turning your body and snapping your arm!',
      },
      {
        time: 170,
        text: "Let's drill it! We're going to do twenty throws just focusing on 'Point, Step, and Throw!' Don't worry about hitting the bullseye yet, just get the ball to the target. Ready? Go!",
      },
      {
        time: 240,
        text: "You're doing great! Remember to finish your throw every time, with your hand by your opposite pocket! Ten more throws! Point, Step, Throw!",
      },
      {
        time: 290,
        text: "You've got the motion down! Now it's time for our first game: THE BULLSEYE CHALLENGE!",
      },
      {
        time: 305,
        text: "Your target is that small piece of tape! That is the bullseye! Every time you hit it, you get a point! You have thirty throws. Let's see how many points you can get! Take your time and focus. Go!",
      },
      {
        time: 375,
        text: "You're halfway through! Fifteen more throws! Remember, Point, Step, Throw! Keep your eye on that bullseye!",
      },
      {
        time: 435,
        text: "Five throws left! Let's finish strong! Can you get two more bullseyes?",
      },
      {
        time: 465,
        text: 'Great job! How many points did you get? Awesome! Now for Game Two: THE KNEELING CANNON!',
      },
      {
        time: 480,
        text: 'This drill will make your arm super strong and accurate. Put your throwing-side knee on the ground, with your other foot up. From here, you can only use your body twist and your arm to throw! This is tough, but it builds a cannon!',
      },
      {
        time: 505,
        text: "Let's do fifteen throws from this position. Focus on turning your shoulders and snapping your wrist. Aim for the bullseye! Go!",
      },
      {
        time: 575,
        text: "You're doing great! This is a real challenge! Five more throws from the knee!",
      },
      {
        time: 605,
        text: 'Fantastic! Stand up and shake out your arm. Time for our final and toughest game: THE FOUR CORNERS CHALLENGE!',
      },
      {
        time: 620,
        text: "Imagine a big square box around your bullseye. There are four corners: top right, top left, bottom left, and bottom right. I'm going to call out a corner, and you have to try and hit it! This is what real pitchers do!",
      },
      {
        time: 645,
        text: "Ready? Our first target is the TOP RIGHT corner! Let's do ten throws to the top right! Go!",
      },
      {
        time: 695,
        text: "Great! Now, let's aim for the TOP LEFT corner! Ten throws! Point, Step, Throw!",
      },
      {
        time: 745,
        text: "You're painting the corners! Now for the BOTTOM LEFT corner! Ten throws! Keep your focus!",
      },
      {
        time: 795,
        text: "Last one! Let's hit the BOTTOM RIGHT corner! Ten more throws to win the game! You can do it!",
      },
      {
        time: 845,
        text: "YOU DID IT! You passed the Laser Show challenge and you're an official pitching ace! Your accuracy is amazing!",
      },
      {
        time: 860,
        text: "Time for our Ace's Cool-down. Take a deep breath. Let's stretch that golden arm. Gently pull your right arm across your chest and hold for ten seconds.",
      },
      {
        time: 880,
        text: 'Now your left arm. Pull it across and hold for ten seconds.',
      },
      {
        time: 900,
        text: 'Great job today! You learned the secrets to throwing lasers and you rocked all the challenges. You should be very proud!',
      },
      {
        time: 915,
        text: "Let's finish like a pro. Stand tall, look at your target, and give a confident champion's nod. Fantastic work today, ace!",
      },
    ],
    timeTotal: 925,
    equipment: 'Foam or soft ball; optional chest-height wall target',
  },
  //done 1
  {
    id: 2148,
    name: 'Advanced Throwing Quick Release',
    categories: ['Throwing', 'advanced'],
    sports: ['baseball'],
    difficulty: 'advanced',
    skill: 'Throwing',
    points: 45,
    instructions:
      "Get ready for the Cannon Arm Challenge! This mission is all about developing a lightning-fast throw. You'll learn the secrets to a quick release, practice throwing from different positions, and play awesome games to test your speed and accuracy. Let's fire up that cannon!",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome to the Cannon Arm Challenge! Before we start, let's go over our safety rules. We are only using a soft foam ball, and making gentle, chest-height throws to a partner or a wall target. Make sure your space is clear!",
      },
      {
        time: 15,
        text: "Great! Let's warm up that arm! Ten big arm circles forward with your throwing arm... and ten big arm circles backward!",
      },
      {
        time: 35,
        text: 'Awesome! Now, twenty fast feet in place to get your body ready! Go, go, go!',
      },
      {
        time: 50,
        text: "Perfect! Let's practice the throwing motion without a ball. We call these shadow throws. Pretend to catch the ball, bring it to your chest, turn your body, and throw! Let's do ten perfect shadow throws!",
      },
      {
        time: 80,
        text: "You're ready! The secret to a quick throw is a lightning-fast transfer! That means getting the ball from your glove to your throwing hand super fast, right at your chest!",
      },
      {
        time: 100,
        text: "Let's play a game called Hot Potato! Your partner will toss you the ball. You're going to catch it, and as fast as you can, get it from your glove to your throwing hand, and then put it right back in your glove! We're not throwing yet! Let's do this fifteen times! Fast hands!",
      },
      {
        time: 150,
        text: "Your hands are like lightning! Now let's add the throw! This is the Catch and Fire drill! You'll catch the ball, do your super-fast transfer at your chest, and fire it right back to the target! Let's do twenty throws! Go!",
      },
      {
        time: 210,
        text: 'Keep going! Remember to turn your hips and shoulders to help your arm! Ten more!',
      },
      {
        time: 250,
        text: "Awesome job! You've mastered the lightning release! Now let's play Game One: The Shuffle and Snipe! Pro infielders are always moving their feet!",
      },
      {
        time: 270,
        text: "We're going to take a quick shuffle step to your right, plant your feet, and make a lightning fast throw! Let's do ten throws shuffling to the right! Go!",
      },
      {
        time: 310,
        text: 'Great footwork! Now ten throws shuffling to the left! Quick shuffle, plant, and FIRE!',
      },
      {
        time: 350,
        text: "You're moving like a pro! Now for the Sniper Challenge! Let's see how accurate you are. We're going to do ten more shuffles, but you have to try and hit a super small target, like a sticker on the wall or your partner's glove! Be a sniper!",
      },
      {
        time: 395,
        text: 'Incredible accuracy! You passed the challenge! Now for Game Two: The One-Knee Cannon!',
      },
      {
        time: 410,
        text: "Sometimes in a game, you have to make a throw from your knees! Let's get down on one knee, with your throwing-side knee on the ground. Catch the ball, and use your whole body to turn and make a strong, fast throw from your knee!",
      },
      {
        time: 435,
        text: "Let's do ten throws with your right knee down! Go!",
      },
      {
        time: 475,
        text: 'Now switch! Ten throws with your left knee down. It feels different, but you can do it!',
      },
      {
        time: 515,
        text: "ONE-KNEE ACCURACY CHALLENGE! Get back on your stronger knee. Let's see if you can hit the target five times in a row without missing! You need laser focus for this! Go!",
      },
      {
        time: 555,
        text: 'You are a master of tricky throws! Time for our next game: THE TARGET LADDER! This is a pro drill to test your accuracy all over the place!',
      },
      {
        time: 575,
        text: "Imagine five targets: LOW, KNEES, CHEST, LEFT SHOULDER, and RIGHT SHOULDER. I'm going to call out a target, and you have to shuffle and hit it as fast as you can! Ready?",
      },
      {
        time: 600,
        text: 'CHEST! ... Now LEFT SHOULDER! ... Now LOW! ... Now KNEES! ... Now RIGHT SHOULDER! ... And back to CHEST!',
      },
      {
        time: 630,
        text: "Awesome! Let's do that ladder again, but even faster! No mistakes! Ready? GO! CHEST! LEFT SHOULDER! LOW! KNEES! RIGHT SHOULDER! CHEST!",
      },
      {
        time: 660,
        text: 'You climbed the ladder like a champion! You are ready for the final challenge... THE CANNON ARM FINALE!',
      },
      {
        time: 680,
        text: 'This is it! You have sixty seconds to make as many fast, accurate throws as you can from a standing position. Every throw that hits the chest-high target is a point! How many points can you get? On your mark... get set... GO!',
      },
      {
        time: 710,
        text: "Thirty seconds left! Keep those hands fast! Quick transfer, quick throw! You've got this!",
      },
      {
        time: 740,
        text: 'Ten, nine, eight, seven, six, five, four, three, two, one! TIME! Count up your points!',
      },
      {
        time: 755,
        text: "Whatever your score, you are a winner! You have officially completed the Cannon Arm Challenge! Let's do our pro cool-down.",
      },
      {
        time: 770,
        text: 'Take a deep breath. Gently pull your throwing arm across your chest to stretch your shoulder. Hold for ten seconds.',
      },
      {
        time: 785,
        text: 'Now switch arms. Pull your other arm across your chest.',
      },
      {
        time: 800,
        text: 'Now, reach your throwing arm up and bend it behind your head. Gently pull your elbow with your other hand to stretch your tricep. Hold it... and switch arms.',
      },
      {
        time: 820,
        text: 'Great job today! You learned how to get the ball out of your glove like lightning and throw with amazing accuracy. You have a cannon arm!',
      },
      {
        time: 835,
        text: "Let's finish with a sign of respect. Stand tall, feet together... and take a proud, champion's bow. Fantastic work today, All-Star!",
      },
    ],
    timeTotal: 845,
    equipment: 'Foam or soft ball; optional chest-height wall target',
  },
  //done 1
  {
    id: 2149,
    name: 'Complete Individual Baseball',
    categories: ['Complete', 'advanced'],
    sports: ['baseball'],
    difficulty: 'advanced',
    skill: 'Complete',
    points: 60,
    instructions:
      "Welcome to the All-Star Game! Today, you're not just one player, you're the whole team! We'll step up to the plate for some power hitting, make amazing plays in the field, and throw some super-fast pitches. It's time to show everyone you're a true All-Star!",
    timedInstructions: [
      {
        time: 0,
        text: 'Welcome to the All-Star Game! First, a quick safety check: We are only using soft foam or wiffle balls, and hitting and throwing only into a net or a soft wall. Make sure your space is clear!',
      },
      {
        time: 15,
        text: "Let's get our bodies ready with a pro warm-up! Twenty Star Jumps! Go!",
      },
      {
        time: 40,
        text: "Great! Now twenty torso twists to get our bodies ready to swing and throw! Let's go!",
      },
      {
        time: 65,
        text: 'Now twenty High Knees to get our feet ready for fielding! Quick feet!',
      },
      {
        time: 85,
        text: "Awesome! Time for Super Focus Mode! Close your eyes. Picture the big game, the lights are bright, and the crowd is cheering your name! You're ready to be the hero! Okay, open your eyes! Let's play ball!",
      },
      {
        time: 110,
        text: "It's the first inning, and you're up to bat! Let's do some BATTING PRACTICE! Get your bat and tee ready. Let's quickly review our All-Star Stance: Superhero Feet, Springy Knees, and line up those door-knocking knuckles!",
      },
      {
        time: 135,
        text: "And the Rocket Swing! Remember? Coil, step, LAUNCH, and hold your Superhero Pose! Let's take ten shadow swings to get loose!",
      },
      {
        time: 175,
        text: "Great swings! Put a ball on the tee right in the middle. Inning one is all about making solid contact. Let's hit ten frozen ropes right into the net! Go!",
      },
      {
        time: 235,
        text: "Inning two! Time for Painting the Corners! Let's hit eight balls on the inside corner! Move the tee closer to you and be quick with your hands!",
      },
      {
        time: 295,
        text: 'Great job! Now eight balls on the outside corner! Move the tee away and hit it to the opposite side of the net!',
      },
      {
        time: 355,
        text: "You're a hitting machine! It's the bottom of the third inning, bases loaded... it's time for the HOME RUN DERBY! You have ninety seconds to hit as many home runs as you can! Ready... GO!",
      },
      {
        time: 400,
        text: 'Halfway there! 45 seconds left! Keep swinging for the fences! Every hard hit is a home run!',
      },
      {
        time: 445,
        text: 'Ten, nine, eight, seven, six, five, four, three, two, one! TIME! What a show!',
      },
      {
        time: 465,
        text: "Great hitting! Put the bat and tee away safely. Now it's time to play the field! Grab your glove if you have one!",
      },
      {
        time: 480,
        text: "It's inning four, and we're playing defense! Let's practice being a Ground Ball Gobbler! Get in your Superhero Stance: feet wide, knees bent, bottom low!",
      },
      {
        time: 500,
        text: "Let's play the Roll and Gobble game! Roll the ball out, get low, and gobble it up with your glove monster and your Alligator Chomp! Let's do fifteen reps!",
      },
      {
        time: 570,
        text: "Inning five! Time for the Three-Lane Challenge! Let's do eight rolls to your glove side! Move your feet and get in front of the ball!",
      },
      {
        time: 620,
        text: 'Great! Now eight rolls right down the middle! Easy plays!',
      },
      {
        time: 670,
        text: 'And now eight rolls to your backhand side! This is the tough play! Go, go, go!',
      },
      {
        time: 720,
        text: "You're unstoppable! Inning six, here comes the POP FLY CHALLENGE! Now we look up! I want you to gently toss the soft ball up in the air, get under it, and catch it with two hands like you're catching a giant water balloon!",
      },
      {
        time: 745,
        text: "Call for it! Shout 'I GOT IT!' on every catch! Let's catch fifteen pop flies!",
      },
      {
        time: 815,
        text: "Great fielding! Put your glove away. It's the end of the game and you're coming in to pitch! It's time to take the PITCHER'S MOUND!",
      },
      {
        time: 830,
        text: "It's inning seven, time to learn the Fastball! Grab your soft ball. The secret is: Point your glove at the target, make a 'T' with your arms, take a big step, and throw! Let's do fifteen gentle throws into the net or pad.",
      },
      {
        time: 900,
        text: "Great throws! Inning eight, we're doing the Knee-Down Drill to build arm strength. Get down on one knee. This helps you focus only on your arm! Let's do ten one-knee throws. No need to throw hard, just make it smooth.",
      },
      {
        time: 960,
        text: "It's the bottom of the ninth inning! Two outs, bases loaded! You need ONE MORE STRIKE to win the All-Star Game! Your challenge is to throw three perfect strikes right into the middle of your target. Take your time... focus... here's the first pitch!",
      },
      {
        time: 1000,
        text: "Keep going! You've got this! Let's see that championship pitch! Focus and throw!",
      },
      {
        time: 1040,
        text: 'STRIKE THREE! YOU DID IT! YOU WON THE ALL-STAR GAME! YOU ARE THE MVP!',
      },
      {
        time: 1055,
        text: "Let's celebrate with the Post-Game Cool-down. Take a deep breath! You were amazing!",
      },
      {
        time: 1070,
        text: 'Time for our final Super Focus Mode. Close your eyes. Picture your best moment from the game. Was it a home run? A diving catch? The final strike? Hold that picture in your mind.',
      },
      {
        time: 1095,
        text: "Now open your eyes. Let's stretch. Gently pull your right arm across your chest, then your left arm. You used your whole body today.",
      },
      {
        time: 1120,
        text: 'Now a gentle stretch for your legs. Pull your right foot to your back, then your left foot. You were an all-star hitter, fielder, AND pitcher!',
      },
      {
        time: 1145,
        text: "You should be so proud of your hard work. You are a true champion. Let's finish with our sign of respect. Stand tall, feet together... and take a deep, proud, All-Star bow.",
      },
    ],
    timeTotal: 1160,
    equipment:
      'Foam or wiffle balls, bat or short bat, tee, glove, net or padded wall, small bucket or box',
  },
];

export default baseballDrills;
